import { cn as e } from "../shared/utils.js";
import { Badge as t } from "./badge.js";
import { forwardRef as n } from "react";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
import { cva as a } from "class-variance-authority";
//#region src/badge/status.tsx
var o = a("max-w-full min-w-0 shrink whitespace-normal", {
	defaultVariants: { size: "md" },
	variants: { size: {
		sm: "min-h-3.5 px-1.5 py-1 gap-1.5 text-xs",
		md: "min-h-6 px-2.5 py-1 gap-1.5 text-sm",
		lg: "min-h-8 px-3 py-1.5 gap-1.5 text-base"
	} }
}), s = a("shrink-0 size-1.5 self-center rounded-full", {
	defaultVariants: { color: "active" },
	variants: { color: {
		active: "bg-icon-success",
		inactive: "bg-icon-tertiary",
		error: "bg-icon-error",
		warning: "bg-icon-warning",
		blue: "bg-icon-accent"
	} }
}), c = n(({ children: n, size: a, className: c, circleProps: l, color: u, ...d }, f) => {
	let { className: p, ...m } = l ?? {};
	return /* @__PURE__ */ i(t, {
		ref: f,
		color: "outlinedGray",
		size: "lg",
		shape: "pill",
		className: e(o({
			className: c,
			size: a
		})),
		...d,
		children: [/* @__PURE__ */ r("span", {
			"aria-hidden": "true",
			className: e(s({
				className: p,
				color: u
			})),
			...m
		}), /* @__PURE__ */ r("span", {
			className: "min-w-0",
			children: n
		})]
	});
});
c.displayName = "Status";
//#endregion
export { c as Status };
